module.exports = __webpack_public_path__ + "img/prize-xsd-dark.9a02e359.png";